import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import Title from '../../Title';
import SiteOwnershipCard from './SiteOwnershipCard';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Skeleton } from '@material-ui/lab';

class SiteOwnership extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux State
        currentTitle: PropTypes.object
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, currentTitle } =this.props;
        const ccod = (currentTitle && currentTitle.ccod);
        const ocod = (currentTitle && currentTitle.ocod);

        return (
            <>
                {
                    (!currentTitle || (currentTitle && (ccod || ocod))) && <Title
                        title="SITE OWNERSHIP"
                        skeleton={!currentTitle}
                    />
                }
                {!currentTitle && <Skeleton animation="wave" height={100} variant="rect" />}
                {
                    ccod && ccod.proprietors.map((proprietor, idx) => (
                        <SiteOwnershipCard
                            key={idx}
                            categoryAggregate={ccod.categoryAggregate}
                            category={proprietor.category}
                            color={'#D6D6FF'}
                            date={ccod.dateProprietorAdded}
                            company={proprietor.name}
                            address={`${proprietor.address1}`}
                            url={proprietor.url}
                        />
                    ))
                }
                {
                    ocod && ocod.proprietors.map((proprietor, idx) => (
                        <SiteOwnershipCard
                            key={idx}
                            categoryAggregate={ocod.categoryAggregate}
                            category={proprietor.category}
                            color={'#D6D6FF'}
                            date={ocod.dateProprietorAdded}
                            company={proprietor.name}
                            address={`${proprietor.address1}`}
                            url={proprietor.url}
                        />
                    ))
                }
            </>
        );
    }
}

const style = theme => ({

});

const mapStateToProps = (state) => {
    const currentPolygon = state.parcelPanel.polygons[state.parcelPanel.currentPolygonId];
    return {
        currentTitle: currentPolygon && state.parcelPanel.titles[currentPolygon.titleNo]
    };
};

const mapDispatchToProps = (dispatch) => ({

});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(SiteOwnership);